import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TFormToggleLabelContainerProps } from '@/shared/components/ui/form/components/form-toggle/form-toggle.types';

export const FormToggleLabelContainer = styled(
  Stack,
)<TFormToggleLabelContainerProps>`
  && {
    padding: ${({ $position }) =>
      $position === 'left' ? '0 1rem 0 0' : '0 0 0 1rem'};
  }
`;
